module.exports = __webpack_public_path__ + "img/cypress2.ac36a3bf.png";